import React, { useEffect } from 'react'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import {
  ActionButton,
  Container,
  HeroWrap,
  InfoWrap,
  Overlay,
  SubTitle,
  Title,
  Video,
} from 'artkive/pages/Home/HeroSection.style'
import routes from 'artkive/utils/routes'

import VideoPosterMobile from 'images/ecom/home/video-poster/720p.jpg'
import VideoPosterTablet from 'images/ecom/home/video-poster/1080p.jpg'
import VideoPosterDesktop from 'images/ecom/home/video-poster/poster.jpg'

const VIDEO_TAG_ID = 'hero-video'

// const isSafari = () => {
//   if (typeof navigator === 'undefined' || !navigator.userAgent || !navigator.vendor) {
//     return false
//   }
//
//   const ua = navigator.userAgent.toLowerCase()
//
//   // Check if it's Safari
//   // Safari has "Safari" in UA but not "Chrome", "Chromium", "Android", "Edge", "OPR", "FxiOS"
//   // Safari also has "Apple Computer, Inc." in navigator.vendor
//   return (
//     ua.indexOf('safari') !== -1 &&
//     ua.indexOf('chrome') === -1 &&
//     ua.indexOf('chromium') === -1 &&
//     ua.indexOf('android') === -1 &&
//     ua.indexOf('edge') === -1 &&
//     ua.indexOf('opr') === -1 &&
//     ua.indexOf('fxios') === -1 &&
//     navigator.vendor.indexOf('Apple Computer') !== -1
//   )
// }

const HeroSection = () => {
  const muiTheme = useTheme()
  const isMobile = useMobileBreakpoint()

  const tabletBreakpoint = muiTheme.breakpoints.values.md // 960
  const mobileBreakpoint = muiTheme.breakpoints.values.sm // 600
  const isDesktop = useMediaQuery(muiTheme.breakpoints.up(tabletBreakpoint))
  const isTablet = useMediaQuery(muiTheme.breakpoints.up(mobileBreakpoint))

  // const isSafariBrowser = useMemo(() => isSafari(), [])

  useEffect(() => {
    const setPoster = () => {
      const video = document.getElementById(VIDEO_TAG_ID)
      if (isDesktop) {
        video.poster = VideoPosterDesktop
      } else if (isTablet) {
        video.poster = VideoPosterTablet
      } else {
        video.poster = VideoPosterMobile
      }
    }

    setPoster()
  }, [isTablet, isDesktop])

  return (
    <HeroWrap>
      <Container>
        <Overlay />
        <Video
          id={VIDEO_TAG_ID}
          autoPlay={true}
          muted={true}
          loop={true}
          playsInline={true}
        >
          <source
            src={'https://artkive-public-assets.s3.us-east-1.amazonaws.com/videos/hero-video-4K.mp4'}
            type={'video/mp4'}
            media={`(min-width: ${tabletBreakpoint}px)`}
          />
          <source
            src={'https://artkive-public-assets.s3.us-east-1.amazonaws.com/videos/hero-video-1080p.mp4'}
            type={'video/mp4'}
          />
        </Video>
        <InfoWrap>
          <Title variant={'h1'}>
            The #1 solution<br />for preserving and celebrating kids&apos; art!
          </Title>
          <SubTitle variant={isMobile ? 'body1' : 'subtitle1'}>
            We transform your piles of kid art into Art Books and Framed Mosaics.
          </SubTitle>
          <ActionButton
            color={'primary'}
            variant={'contained'}
            href={routes.boxCheckout}
            trackerEvent={GET_BOX_CLICK}
            trackerOptions={{ section: 'home_start_banner' }}
          >
            Get My Box
          </ActionButton>
        </InfoWrap>
      </Container>
    </HeroWrap>
  )
}

export default HeroSection
